import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

import moment from 'moment';
import Sidebar from 'components/Sidebar';

import './styles.scss';

import {setCurrentUser} from 'actions/index';

import getUserInfo from 'api/getUserInfo';
import getLanguageConfig from 'api/getLanguageConfig';

import getUserStage from 'utils/getUserStage';
import strings, {applyOverrides} from 'utils/strings';

import {TRIAL} from 'constants/index';

const APP = 'backoffice';

class Backoffice extends React.Component {
	constructor() {
		super();

		this.fetchUserInfo = this.fetchUserInfo.bind(this);
	}
	componentDidMount() {
		this.fetchUserInfo();
	}

	fetchUserInfo() {
		const {handleSetCurrentUser} = this.props;

		Promise.all([getUserInfo(), getLanguageConfig(APP)])
			.then(([user, overrides]) => {
				applyOverrides(overrides);
				const langObject = user.subscription.languages[0];
				const isNormingUser =
					langObject.norming_adult === 1 ||
					langObject.norming_child === 1 ||
					langObject.norming_youth === 1;

				let isLoggedIn = false;
				if (user.subscription.super) {
					user.isSuperAdmin = true;
					user['isNormingAdmin'] = isNormingUser;
					user.userStage = getUserStage(user);
					isLoggedIn = true;
				} else {
					user.isSuperAdmin = false;
					user['isNormingAdmin'] = isNormingUser;
					user.userStage = getUserStage(user);
					isLoggedIn = true;
				}
				const {unReadNotifications = []} = user;

				handleSetCurrentUser({
					...user,
					unReadNotificationsCount: unReadNotifications.length,
				});

				if (!isLoggedIn) {
					throw new Error('Unauthorized error');
				}
			})
			.catch(() => {
				window.location.href = '/login';
			});
	}

	render() {
		const {currentUser} = this.props;
		if (!currentUser) {
			return null;
		}
		const {isSuperAdmin} = currentUser;
		let trialExpiryText;

		const now = moment();
		if (currentUser.userStage === TRIAL) {
			const trialValidUntilMoment = moment(
				currentUser.subscription.trialValidUntil
			);
			if (trialValidUntilMoment.isAfter(now)) {
				trialExpiryText = strings.formatString(
					strings.trialExpiresInPrefix,
					trialValidUntilMoment.fromNow(true)
				);
			} else {
				trialExpiryText = strings.trialExpiredShort;
			}
		}

		return (
			<div>
				<Sidebar
					isSuperAdmin={isSuperAdmin}
					currentUserInfo={currentUser}
				/>
				<div className="lit-view">
					<header className="lit-header">
						<div />
					</header>
					<div className="lit-view__content">
						{this.props.children}
					</div>
				</div>
			</div>
		);
	}
}

Backoffice.propTypes = {
	currentUser: PropTypes.shape({}),
};

const mapStateToProps = (state) => {
	const {currentUser} = state;

	return {
		currentUser,
	};
};

const mapDispatchToProps = {
	handleSetCurrentUser: setCurrentUser,
};

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(Backoffice)
);
